export interface IPrice {
  unit_amount: number;
  price_id: string;
}

export enum ModeEnum {
  Full = 'full',
  Widget = 'widget',
  Paywall = 'paywall',
  PaywallLight = 'paywall-light',
  SportPlans = 'sport-plans',
}

export enum ItemTypeEnum {
  custom = 'custom',
  plan = 'plan',
  one_payment = 'one_payment'
}

export type IItem = IOneTimePaymentItem | IPlan | ICustomPlan;

export interface IOneTimePaymentItem {
  type: ItemTypeEnum.one_payment;
  plan_id: string;
  disabled: boolean;
  current?: IBoughtOnePaymentItem;
  display: {
    name: string;
    sport_category: string;
  }
  prices: {
    once: IPrice,
  }
}

export enum RealmEnum {
  Bets = 'bets',
  Dfs = 'dfs',
  Dvoa = 'dvoa',
  Fantasy = 'fantasy',
}

export interface IPlan {
  type: ItemTypeEnum.plan
  isAdditional?: boolean;
  plan_id: string;
  plan_tier: number;
  disabled: boolean;
  display: {
    border_color: string;
    accent_color: string;
    name: string;
    sport_category: string;
    default_upgrade_plan_id: string;
  }
  prices: {
    yearly: IPrice,
    monthly: IPrice,
  }
  current?: ISubscriptionPlan;
  additional?: IPlan;
  encapsulated_plans: string[];
  childPlans?: IPlan[];
  features: string[];
  permissions_tiers: { [key in RealmEnum]: Record<string, number> }
}

export interface ICustomPlan {
  type: ItemTypeEnum.custom
  plan_id: string;
  plan_tier: number;
  display: {
    name: string;
    sport_category: string;
    subname: string;
  }
  features: string[];
  customText: string;
  customLink: string;
}

export interface IPlanSubscribed extends IPlan, Omit<ISubscription, 'plans'> {
  'interval': 'year' | 'month',
  'price_id': string,
  'price': string,
}

export interface ISubscriptionPlan {
  'plan_id': string,
  'display_name': string,
  'price_id': string,
  'price': string,
  'interval': 'year' | 'month';
  'subscription'?: ISubscription;
}

export interface ISubscription {
  'subscription_id': string,
  'status': 'active' | string,
  'billing_cycle_anchor': number,
  'cancel_at_period_end': boolean,
  'canceled_at': number | null,
  'cancel_at': number | null,
  'created_at': number,
  'current_period_end': number,
  'current_period_start': number,
  'trial_start': number | null,
  'trial_end': number | null,
  'discount': {},
  'plans': ISubscriptionPlan[]
}

export interface IOnePaymentItemDiscount {
  'plan_id': string,
  'amount_off': number,
  'pct_off': number,
  'period_restriction': string
}

export interface IOnePaymentItem {
  'id': number,
  'string_id': string,
  'name': string,
  current?: IBoughtOnePaymentItem;
  'description': string,
  'available': boolean,
  'base_price': number,
  'subscriber_price': number,
  'subscriber_period_restriction': string,
  'subscriber_sports_restriction': string[],
  'discounts': IOnePaymentItemDiscount[]
}

// export interface IPlan {
//   plan_id: string;
//   encapsulated_plans: string[];
//   childPlans?: IPlan[];
//   plan_tier: number;
//   disabled: boolean;
//   current?: ISubscriptionPlan;
//   additional?: IPlan;
//   display: {
//     border_color: string;
//     accent_color: string;
//     name: string;
//     sport_category: string;
//     default_upgrade_plan_id: string;
//   }
//   prices: {
//     yearly: IPrice,
//     monthly: IPrice
//   }
//   features: string[]
// }

export interface IBoughtOnePaymentItem {
  active: boolean
  id: number,
  purchase_date: string,
  item: {
    'available': boolean,
    'base_price': number,
    description: string,
    id: number,
    name: string,
    string_id: string,
    subscriber_period_restriction: 'yearly' | 'monthly',
    subscriber_price: number
    subscriber_sports_restriction: string[],
  }
}

declare global {
  interface Window {
    defaultSport?: string;
    baseURL?: string;
  }
}
